import RegionModel from 'Models/RegionModel';

const WowDiscoveryModel = {};

// Не забудь обновить бэк.
// @see \App\Types\Maps\ServerMap -> ProductGameEnum::GAME_WOW_DISCOVERY -> RegionMap::REGION_ID_EU
WowDiscoveryModel[RegionModel.EU.id] = [
  {
    id: 1,
    title: 'Wild Growth',
  },
  {
    id: 2,
    title: 'Living Flame',
  },
  {
    id: 3,
    title: 'Lone Wolf',
  },
  {
    id: 4,
    title: 'Lava Lash',
  },
  {
    id: 5,
    title: 'Crusader Strike',
  },
  {
    id: 6,
    title: 'Chaos Bolt',
  },
];

// Не забудь обновить бэк.
// @see \App\Types\Maps\ServerMap -> ProductGameEnum::GAME_WOW_DISCOVERY -> RegionMap::REGION_ID_USA
WowDiscoveryModel[RegionModel.USA.id] = [
  {
    id: 1,
    title: 'Wild Growth',
  },
  {
    id: 2,
    title: 'Penance',
  },
  {
    id: 3,
    title: 'Living Flame',
  },
  {
    id: 4,
    title: 'Lone Wolf',
  },
  {
    id: 5,
    title: 'Shadow Strike',
  },
  {
    id: 6,
    title: 'Lava Lash',
  },
  {
    id: 7,
    title: 'Crusader Strike',
  },
  {
    id: 8,
    title: 'Chaos Bolt',
  },
];

// eslint-disable-next-line import/prefer-default-export
export { WowDiscoveryModel };
